import { render, staticRenderFns } from "./showPerson.vue?vue&type=template&id=591fb1f4&scoped=true&"
import script from "./showPerson.vue?vue&type=script&lang=js&"
export * from "./showPerson.vue?vue&type=script&lang=js&"
import style0 from "./showPerson.vue?vue&type=style&index=0&id=591fb1f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591fb1f4",
  null
  
)

export default component.exports